export default {
  navMenuItems({ commit }) {
    commit('SET_NAV_MENU_ITEMS')
  },
}
